<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月24日 16:45:35
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div class="dialog-container">
        <el-dialog
          :append-to-body="false"
          :modal-append-to-body="false"
            class="dialog"
            :show-close="false"
            :visible.sync="dialogVisible"
            :width="dialogWidth"
            :before-close="close">
            <slot>
              <div class="dialog">
                <div class="dialog-main">
                  <div class="dialog-title">
                    <el-image
                    class="dialog-image"
                    :src="lanjingao"></el-image>
                    <div class="dialog-tips" >{{question}}</div>
                  </div>
                </div>
                <div class="dialog-footer">
                  <el-button @click="close()" class="dialog-btn dialog-cancal">取消</el-button>
                  <el-button @click="setup()" class="dialog-btn dialog-sure" type="primary">确定</el-button>
                </div>
              </div>
            </slot>
        </el-dialog>
    </div>
</template>

<script>
import lanjingao from '@/assets/imgs/lanjingao.png'
export default {
  // 组件参数 接收来自父组件的数据
  props: {
    dialogWidth:String,
    dialogVisible:Boolean,
    question:String,
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {
      lanjingao
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    close(){
      this.$emit('close')
    },
    setup(){
      this.$emit('close')
      this.$emit('setup')
    }
  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
  * 在实例初始化之后，组件属性计算之前，如data属性等
  */
  beforeCreate () {
  },
  /**
  * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
  */
  created () {
  },
  /**
  * 在挂载开始之前被调用：相关的 render 函数首次被调用。
  */
  beforeMount () {
  },
  /**
  * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
  * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
  */
  mounted () {
  },
  /**
  * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
  * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  */
  beforeUpdate () {
  },
  /**
  * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
  * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
  */
  updated () {
  },
  /**
  * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
  */
  activated () {
  },
  /**
  * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
  */
  deactivated () {
  },
  /**
  * 实例销毁之前调用。在这一步，实例仍然完全可用。
  */
  beforeDestroy () {
  },
  /**
  * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
  * 所有的事件监听器会被移除，所有的子实例也会被销毁。
  */
  destroyed () {
  }
}
</script> 

<style scoped>


.dialog{
  font-size: 14px;
  padding: 20px 28px;
  text-align: center;
}
.dialog-main{
  display: inline-block;
}
.dialog-title{
  margin: 0px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0px;
}
.dialog-image{
  width: 16px;
  height: 16px;
}
.dialog-tips{
  font-weight: 500;
  margin-left: 6px;
  color: #0A0E10;
  flex: 1;
}
.dialog-footer{
  margin: 0px auto;
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
}

.dialog-cancal{
  border: 1px solid #EBEBEB;
  color: #C7C9CC;
}
.dialog-sure{
  background: #029FD1;
}

.dialog-container >>> .el-dialog{
    border-radius: 5px;
}
.dialog-container >>> .el-dialog__header{
    height: 0px;
    padding: 0px;
}
.dialog-container >>> .el-dialog__body{
    padding: 0px;
}

.dialog-btn {
    width: 69px;
    height: 32px;
    line-height: 8px;
    font-size: 14px;
}

.dialog-container >>> .el-dialog{
    margin-top: 0px !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
</style>



// WEBPACK FOOTER //
// src/common/dialog.vue